import { useEffect } from "react";
import CostValue from "../CostValue";
import RealTimeParent from "./RealTimeParent";
import AboutUsNavHeader from "./aboutus/AboutUsNavHeader";
import AboutUsNavContent from "./aboutus/AboutUsNavContent";
import OurValuesandMeetOurTeam from "./aboutus/OurValuesandMeetOurTeam";
import FaqNavHeader from "./faq/FaqNavHeader";
import PricingNavHeader from "./pricing/PricingNavHeader";
import DemoNavHeader from "./demo/DemoNavHeader";
import BlogNavHeader from "./blog/BlogNavHeader";
import BlogNavContent from "./blog/BlogNavContent";
import LoginNavHeader from "./login/LoginHeader";
import PrintMaterialNavHeader from "./printmaterial/PrintMaterialNavHeader";
import PrintMaterialNavContent from "./printmaterial/PrintMaterialNavContent";
import KeyFeature from "../KeyFeature";
import WatchOurDemo from "../WatchOurDemo";
import PricingNavContentPage1 from "./pricing/PricingNavContentPage1";
import HearFromOurClient from "../HearFromOurClients";
import FaqNavContent from "./faq/FaqNavContent";
import DemoNavContent from "./demo/DemoNavContent";
import ContactNavHeader from "./contact/ContactNavHeader";
import ContactContent from "./contact/ContactContent";
import PricingNavContentPageCompare from "./pricing/PricingNavContentPageCompare";
import PricingPlan from "./pricing/PricingPlan";
import ScrollToTop from "../../header/ScrollToTop";
// import { useDoubleTickWidget } from "../../../lib/useDoubleTickWidget";
import HowItWorks from "../HowItWorks";
import PricingSection from "../PricingSection";
import SocialProofMetrics from "../SocialProofMetrics";


const LandingNavBar = (props) => {

    // useDoubleTickWidget();

    useEffect(() => {
        if (props.landing === "landing" && typeof window.gtag === 'function') {
            window.gtag('event', 'page_view', { page_title: 'Landing', event_category: 'marketing' });
        }
    }, [props.landing]);
    return (
        <div className="bg-white">
            <ScrollToTop />
            {props.landing === "landing" && <RealTimeParent />}
            {/* <WhatsAppButton /> */}
            {props.landing === "landing" && <HowItWorks />}
            {props.landing === "landing" && <WatchOurDemo />}
            {props.landing === "landing" && <PricingSection />}
            {props.landing === "landing" && <CostValue />}
            {props.landing === "landing" && <KeyFeature />}
            {props.landing === "landing" && <HearFromOurClient />}
            {props.landing === "landing" && <SocialProofMetrics />}

            {/* For About us Nav Bar */}
            {props.navBar === "aboutus" && <AboutUsNavHeader />}
            {props.navBar === "aboutus" && <AboutUsNavContent />}
            {props.navBar === "aboutus" && <OurValuesandMeetOurTeam />}

            {/* For faq Nav Bar */}
            {props.navBar === "faq" && <FaqNavHeader />}
            {props.navBar === "faq" && <FaqNavContent />}
            {/* For pricing Nav Bar */}
            {props.navBar === "pricing" && <PricingNavHeader />}
            {props.navBar === "pricing" && props.page === "pricing" && (<PricingPlan />)}

            {props.navBar === "pricing" && props.page === "pricing" && (
                <PricingNavContentPage1 />
            )}

            {props.navBar === "pricing" && props.page === "compare" && (
                <PricingNavContentPageCompare />
            )}

            {/* For demo Nav Bar */}
            {props.navBar === "demo" && <DemoNavHeader />}
            {props.navBar === "demo" && <DemoNavContent />}


            {/* For blog Nav Bar */}
            {props.navBar === "blog" && <BlogNavHeader />}
            {props.navBar === "blog" && <BlogNavContent />}


            {/* For contact Nav Bar */}
            {props.navBar === "contact" && <ContactNavHeader />}
            {props.navBar === "contact" && <ContactContent />}
            {/* For login Nav Bar */}
            {props.navBar === "login" && <LoginNavHeader />}

            {/* For print material Nav Bar */}
            {props.navBar === "printingmaterial" && <PrintMaterialNavHeader />}
            {props.navBar === "printingmaterial" && <PrintMaterialNavContent />}
        </div>
    )
}

export default LandingNavBar;